import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, PropType } from 'vue';
import { defineMessages } from '@/lib/i18n';

import { hasNoNullText, isNumberAndAlphabetsAndHyphenArray } from '@/lib/rule';
import { textFormList } from '@/lib/formItem';
import { FormItem } from '@/interfaces/lib/model';
import { VForm } from 'vuetify/lib/components';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection14Form',
  props: {
  unNumber: {
    type: String,
    required: true,
  },
  unNumberList: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:isValid", "update:unNumberList"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:unNumberList', data: Array<string>): void;
}), expose: any, slots: any, attrs: any }) {

const m = defineMessages({
  hint: '入力後にEnterキーを押すと複数の値を入力できます',
});



const form = ref<InstanceType<typeof VForm> | null>(null);
const isValid = ref<boolean>(false);



const updateIsValid = (e: boolean) => {
  emits('update:isValid', e);
};

const updateUnNumberList = (e: Array<string | FormItem>) => {
  const data = e.map((item) => {
    if (typeof item == 'string') {
      return item;
    } else {
      return String(item.value);
    }
  });

  emits('update:unNumberList', data);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,m, form, isValid, emits, updateIsValid, updateUnNumberList, hasNoNullText, isNumberAndAlphabetsAndHyphenArray, textFormList, VForm, sharedMessages }
}

})